// import { ChoiceList } from '@shopify/polaris';
import React from 'react';
import Select from 'react-select';
import { handleFilterChange } from '../FilterEngine';

// eslint-disable-next-line
const languageFilterDefinition = (t, props, setTableFilters, options, selected, { inputOptions = {} }) => ({
  key: 'language',
  label: t('user.language'),
  filter: (
    <div className="w-80 h-80 react-select">
      <Select
        // cacheOptions
        placeholder={t('user.search')}
        menuPlacement="bottom"
        inputValue={inputOptions.value}
        isClearable
        onInputChange={inputOptions.setValue}
        value={selected}
        onChange={handleFilterChange(props, setTableFilters, 'languages')}
        // noOptionsMessage="Loading"
        defaultOptions={options}
        menuIsOpen
        isMulti
        options={options}
        getOptionValue={(user) => user.value}
        getOptionLabel={(user) => user.label}
      />
    </div>
    // <ChoiceList
    //   title="Status"
    //   titleHidden
    //   choices={options}
    //   selected={selected}
    //   onChange={handleFilterChange(props, setTableFilters, 'status')}
    //   allowMultiple
    // />
  ),
  shortcut: true
});

export default languageFilterDefinition;
